import { toast, ToastOptions, ToastContent, cssTransition, ToastContainerProps } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, StyledToastContainer } from './style';

const defaultOptions: ToastOptions = {
	closeButton: <CustomClose/>,
	closeOnClick: false,
	draggable: false,
	containerId: 'APP_TOAST'
};

function show(
	type: 'success' | 'error' | 'warn' | 'info' | 'default',
	content: ToastContent,
	options: ToastOptions = {}
) {
	const toastId = options.toastId; // if provided, prevent duplicates
	if (toastId && toast.isActive(toastId)) return; 
	
	const toastOptions = { ...defaultOptions, ...options };

	switch (type) {
	case 'success':
		return toast.success(content, toastOptions);
	case 'error':
		return toast.error(content, toastOptions);
	case 'warn':
		return toast.warn(content, toastOptions);
	case 'info':
		return toast.info(content, toastOptions);
	default:
		return toast(content, toastOptions);
	}
}

export const appToast = {
	...toast,
	success: (c: ToastContent, o: ToastOptions = {}) => show('success', c, o),
	error: (c: ToastContent, o: ToastOptions = {}) => show('error', c, o),
	warn: (c: ToastContent, o: ToastOptions = {}) => show('warn', c, o),
	info: (c: ToastContent, o: ToastOptions = {}) => show('info', c, o),

	// ------- custom type --------------//
	sticky: (c: ToastContent, o: ToastOptions = {}) =>
		show('default', c, { 
			autoClose: false, 
			position: 'bottom-center',
			transition: NoTransition,
			...o
		}),

};

export const CustomToastContainer = (props: ToastContainerProps) => {

	const toastCotainerProps = {
		...defaultOptions,
		...props,
		enableMultiContainer: !!props.containerId,
	};
	return (
		<StyledToastContainer
			{...toastCotainerProps}
		/>
	);
};

function CustomClose({ closeToast }: { closeToast?: () => void }){
	return(
		<Button
			onClick={closeToast}
			className='cancel-prompt'
		>
			<svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path id="cancel-path" d="M0.947266 0.947266L14.2631 14.2631M14.2631 0.947266L0.947265 14.2631"
					stroke='var(--defaultIconColor)'
					strokeWidth="1.6"
					strokeLinecap="round" />
			</svg>
		</Button>
	);
}

const NoTransition = cssTransition({
	enter: 'no-enter',
	exit: 'no-exit',
	appendPosition: false,
	collapse: true,
	collapseDuration: 0,
});